export const ROOT = "/";
export const LOGIN = "/login";
export const HOMEPAGE = "/Home";
export const PROFILE = "/profile/:id";
export const BOUNAKIR = "/Bounakir";
export const BOUNAKIR_WATCH_ME = "/BounakirWatchMe";
export const SIGNUP = "/Signup";
export const SIGNUP_MENU = "/SignupMenu";
export const COMPLETE_SIGNUP = "/Complete";
export const COMPLETE_QUESTIONS = "/CompleteQuestions";
export const SMS_VERIFICATION = "/smsVerification";
export const DOUBLE_MATCH = "/doubleMatch";
export const SELECT_MOOD = "/selectMood";
export const CONVERSTAION = "/converstaion";
export const CHAT = "/chat/:chatMemberCode";
export const ADVANCED_SEARCH = "/advancedSearch";
export const MY_PROFILE = "/myProfile";
export const EDIT_PROFILE = "/editProfile";
export const SETTINGS = "/settings";
export const UPDATE_LOOKING_FOR = "/update_looking_for";
export const ABOUT_ME_SENTENCE = "/update_about_me";
export const UPDATE_BIRTHDATE = "/updateBirthdate";
export const UPDATE_QUESTION_TAG = "/updateQuestionTag/:id";
export const UPDATE_PERSONAL_STATUS = "/updatePersonalStatus";
export const UPDATE_NICKNAME = "/updateNickName";
export const UPDATE_MEMBER_LOCATION = "/updateMemberLocation";
export const UPDATE_EMAIL = "/updateEmail";
export const UPDATE_HEIGHT = "/updateHeight";
export const UPDATE_PASSWORD = "/updatePassword";
export const RESET_PASSWORD = "/resetPassword";
export const EMAIL_VERIFIED = "/emailVerified";
export const ONBORADING_SCREEN = "/onBorading";
export const VERIFY_PROFILE = "/verifyProfile";
export const BOUNKIR_LINKS = "/bounkirLinks";
export const COMPLETED_PROFILE_PAGE = "/completedProfile";
export const PREMIUM_MESSAGE = "/premiumMassage";
export const PREMIUM_PLAN_DETAILS = "/premiumPlanDetails";
export const HOME_SEARCH_USER = "/homeSearchUser";
export const SEARCH_MEMBERS_RESULTS = "/searchMembersResults";
export const PAYMENT_SUCCESS = "/payment-success";
export const PAYMENT_FAILURE = "/payment-failure";
export const TERMS_OF_USE = "/terms-of-use";
export const PRIVACY_POLICY = "/privacy-policy";
